<template>
  <div class="Home-box">
    <div class="HomeView-container">
      <div class="body">
        <!-- <h1><strong>讯天科技</strong></h1>
        <h2>数据要素技术与服务提供商</h2> -->
      </div>
    </div>
    <div class="Content">
      <div class="produce">
        <div class="left">
          <!-- 添加封面图 -->
          <video
            ref="lazyVideo"
            controls="controls"
            :loop="false"
            muted="muted"
            style="width: 100%; height: 100%; object-fit: cover;background-color: #3c3a75"
            :autoplay="false"
          >
            <source src="@/assets/homeVideo.mp4" type="video/mp4" />
          </video>
        </div>
        <div class="righ">
          <h2>鸿诚志远 HongZOS</h2>
          <div
            style="
              margin-top: 20px;
              line-height: 32px;
              color: #3d3d3d;
              font-size: 16px;
            "
          >
            鸿诚志远
            HongZOS是基于OpenHarmony技术底座研发打造的物联网操作系统，致力于赋能千行百业，加速行业数智能化转型。HongZOS
            适配华为海思、龙芯中科、瑞芯微、紫光展锐、全志等30+主流国产品芯片平台，并针对工业、工矿业、交通、教育、驾培、
            警务、政务、智慧城市等多个行业进行了深度定制和优化，全面集成AI和OTA能力，具备资源共享、万物互联、智能协同、
            安全可信等行业价值。诚迈科技还构建了手持终端、平板、智慧屏、网关、开发板、模组等HongZOS产品矩阵，帮助客户加速应用国产化迁移和业务数智化升级。
          </div>
        </div>
      </div>
      <div class="centerall">
        <div class="content-wrapper">
          <img
            style="cursor: pointer"
            src="@/assets/home/homePage.webp"
            alt="背景图"
            class="background-img"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videoSrc: null,
      videoError: false,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>

<style scoped>
.Home-box {
  width: 100%;
  height: 100%;
}
.HomeView-container {
  width: 100%;
  height: 600px;
  background-image: url('@/assets/home/sye.webp');
  background-size: cover;
  position: relative;
}
.body {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
}
.body img {
  width: 34%; /* 5.4375rem 假设 1rem = 16px */
  height: 120px; /* 7.5rem 假设 1rem = 16px */
  object-fit: cover;
}
.body h1 {
  margin-top: 30px;
  font-family: Heavy;
  font-weight: 800;
  font-size: 56px;
  color: #ffffff;
  line-height: 77px;
  height: 77px;
  font-style: normal;
  margin-bottom: 20px;
}
strong {
  font-weight: 900;
  letter-spacing: 2px;
}
.body h2 {
  font-family: Light;
  font-weight: 400;
  font-size: 30px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 42px;
  letter-spacing: 5px;
  font-style: normal;
  margin-bottom: 142px;
}
.Content {
  padding-top: 80px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  height: 100%;
}
.produce {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.left {
  width: 574px;
  height: 323px;
}
.righ {
  width: 689px;
  height: 323px; /* 20.187rem 假设 1rem = 16px */
  margin-left: 50px;
  margin-bottom: 100px;
  h2 {
    margin-top: 45px;
  }
}
.centerall {
  position: relative;
  width: 100%;
  height: 420px;
  overflow: hidden;
  margin-bottom: 80px;
}
.content-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.text-content {
  width: 46%;
  margin-left: 50%;
  color: #fff;
  font-size: 16px;
  line-height: 1.6;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  z-index: 1;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1280px) {
  .centerall {
    height: 360px; /* 小屏显示较小的高度 */
  }
}
/* 图片懒加载样式 */
img[lazy='loading'] {
  opacity: 0;
}

img[lazy='loaded'] {
  opacity: 1;
  transition: opacity 0.5s;
}

img[lazy='error'] {
  opacity: 1;
  background-color: #ccc;
}
/* 手机样式 */
@media (max-width: 768px) {
  .HomeView-container {
    height: 200px;
    background-repeat: repeat;
    background-position: center;
  }
  .Content {
    padding-top: 0;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    height: 100%;
  }
  .body h1 {
    font-size: 32px;
    line-height: 44px;
  }

  .body h2 {
    font-size: 20px;
    letter-spacing: 2px;
  }

  .produce {
    flex-direction: column;
    padding: 0 10px;
  }

  .left {
    width: 100%;
    margin: 20px 0;
  }
  .righ {
    width: 100%;
    height: 424px;
    margin: 0;
    h2 {
      margin-top: 15px;
    }
  }

  .centerall {
    height: 160px;
    padding: 0;
    margin-top: 30px;
    margin-bottom: 0;
  }

  .content-wrapper {
    flex-direction: column;
    align-items: center;
  }

  .text-content {
    margin-left: 0;
    width: 100%;
    text-align: center;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .background-img {
    width: 100%;
    height: auto;
  }
}
</style>
